import React, { useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Calculator, TrendingUp } from 'lucide-react';

const PartnerCalculator = ({ language }) => {
  const [orders, setOrders] = useState(10);
  const [fee, setFee] = useState(15);

  const numOrders = Number(orders) || 0;
  const numFee = Number(fee) || 0;
  const weekly = numOrders * numFee;
  const monthly = weekly * 4;

  const t = language === 'en' ? {
    title: 'Estimate Your Earnings',
    subtitle: 'Enter your numbers to instantly see your potential profit',
    orders: 'Orders per week',
    fee: 'Service fee per order (BZD $)',
    weekly: 'Weekly Profit',
    monthly: 'Monthly Profit',
    note: 'Estimate based on your service fee only. Bulk shipping savings can add even more.'
  } : {
    title: 'Calcula Tus Ganancias',
    subtitle: 'Ingresa tus números para ver al instante tu ganancia potencial',
    orders: 'Pedidos por semana',
    fee: 'Tarifa de servicio por pedido (BZD $)',
    weekly: 'Ganancia Semanal',
    monthly: 'Ganancia Mensual',
    note: 'Estimación basada solo en tu tarifa de servicio. El ahorro en envío al por mayor puede sumar aún más.'
  };

  const fmt = (n) => `$${n.toLocaleString()}`;

  return (
    <Card className="max-w-4xl mx-auto border-2 border-[#8b1538]/20 shadow-xl" data-testid="partner-calculator">
      <CardContent className="p-8">
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-full bg-[#8b1538]/10 flex items-center justify-center mx-auto mb-4">
            <Calculator className="w-7 h-7 text-[#8b1538]" />
          </div>
          <h3 className="text-2xl md:text-3xl font-bold text-[#1e1919]">{t.title}</h3>
          <p className="text-[#736c64] mt-2">{t.subtitle}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-8">
          <div>
            <Label htmlFor="calc-orders" className="text-[#1e1919] font-semibold">{t.orders}</Label>
            <Input
              id="calc-orders"
              type="number"
              min="0"
              value={orders}
              onChange={(e) => setOrders(e.target.value)}
              data-testid="calc-orders-input"
              className="mt-2 border-[#736c64]/30 focus:border-[#8b1538]"
            />
          </div>
          <div>
            <Label htmlFor="calc-fee" className="text-[#1e1919] font-semibold">{t.fee}</Label>
            <Input
              id="calc-fee"
              type="number"
              min="0"
              value={fee}
              onChange={(e) => setFee(e.target.value)}
              data-testid="calc-fee-input"
              className="mt-2 border-[#736c64]/30 focus:border-[#8b1538]"
            />
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          <div className="bg-[#fad24b]/15 rounded-xl p-6 text-center">
            <p className="text-[#736c64] font-semibold mb-1">{t.weekly}</p>
            <p className="text-3xl font-bold text-[#8b1538]" data-testid="calc-weekly-result">{fmt(weekly)}</p>
          </div>
          <div className="bg-[#8b1538] rounded-xl p-6 text-center">
            <p className="text-[#fad24b] font-semibold mb-1 flex items-center justify-center gap-2">
              <TrendingUp className="w-4 h-4" />
              {t.monthly}
            </p>
            <p className="text-4xl font-bold text-white" data-testid="calc-monthly-result">{fmt(monthly)}</p>
          </div>
        </div>

        <p className="text-sm text-[#736c64] text-center mt-6 italic">{t.note}</p>
      </CardContent>
    </Card>
  );
};

export default PartnerCalculator;
